import { chromelessLayout } from '@atlassian/jira-chromeless-layout/src/index.tsx';
import { ThemedLazySkeleton } from '@atlassian/jira-project-theme-components/src/ui/ThemedLazySkeleton.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { jiraSpaResources } from '@atlassian/jira-router-resources-spa-page-container/src/index.tsx';
import { getProjectViewResources } from '@atlassian/jira-router-resources-business-common/src/index.tsx';
import { jiraBusinessCapacityCustomEmbedRoute } from '@atlassian/jira-router-routes-business-capacity-routes/src/jiraBusinessCapacityCustomEmbedRoute.tsx';
import { createChromelessEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { businessCapacityEntryPoint } from '@atlassian/jira-spa-apps-business-capacity/entrypoint.tsx';

const capacityEmbedPageEntrypoint = createChromelessEntryPoint({
	main: businessCapacityEntryPoint,
});

export const jiraBusinessCapacityCustomEmbedRouteEntry = createEntry(
	jiraBusinessCapacityCustomEmbedRoute,
	() => ({
		group: 'classic-business',
		ufoName: 'jwm.jwm-capacity-custom-embed',

		entryPoint() {
			if (__SERVER__) {
				return undefined;
			}
			return capacityEmbedPageEntrypoint;
		},

		layout: chromelessLayout,
		skeleton: ThemedLazySkeleton,
		resources: [...jiraSpaResources(), ...getProjectViewResources()],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-business-capacity-entries/src/jiraBusinessCapacityCustomEmbedRouteEntry.tsx',
				whichExportToUse: 'jiraBusinessCapacityCustomEmbedRouteEntry',
			},

			enabled: true,
		},
	}),
);
